module.exports = __webpack_public_path__ + "static/images/styles/images/buildings/military-school-lvl1-75.22f23f66.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/buildings/military-school-lvl1-75.png
// module id = 3545
// module chunks = 11